import React from 'react';
import { MapPin, Star, ChevronRight } from 'lucide-react';

const SkeletonCard = () => {
  return (
    <div className="glass-card rounded-2xl overflow-hidden">
      {/* Image with Rating Badge - Match h-56 from real cards */}
      <div className="relative h-56 overflow-hidden bg-gradient-to-br from-neutral-200 to-neutral-300 dark:from-neutral-700 dark:to-neutral-800 animate-pulse">
        {/* Glass Rating Badge Skeleton */}
        <div className="absolute bottom-4 left-4 bg-white/95 dark:bg-neutral-800/95 backdrop-blur-xl px-4 py-2 rounded-full flex items-center gap-2 shadow-luxury border border-white/20">
          <Star size={14} className="text-neutral-300 dark:text-neutral-600" />
          <div className="h-4 w-6 bg-neutral-300 dark:bg-neutral-600 rounded"></div>
          <div className="h-3 w-8 bg-neutral-200 dark:bg-neutral-700 rounded"></div>
        </div>
      </div>

      {/* Content - Match p-6 from real cards */}
      <div className="p-6">
        {/* Title */}
        <div className="h-7 w-3/4 bg-neutral-200 dark:bg-neutral-700 rounded animate-pulse mb-2"></div>
        
        {/* Location */}
        <div className="flex items-center gap-2 mb-4">
          <MapPin size={16} className="text-neutral-300 dark:text-neutral-600" />
          <div className="h-4 w-2/5 bg-neutral-200 dark:bg-neutral-700 rounded animate-pulse"></div>
        </div>

        {/* Sports Pills */}
        <div className="flex flex-wrap gap-2 mb-4">
          <div className="h-7 w-20 bg-neutral-200 dark:bg-neutral-700 rounded-full animate-pulse"></div>
          <div className="h-7 w-24 bg-neutral-200 dark:bg-neutral-700 rounded-full animate-pulse"></div>
          <div className="h-7 w-16 bg-neutral-200 dark:bg-neutral-700 rounded-full animate-pulse"></div>
        </div>

        {/* Price Section - Match border-t styling */}
        <div className="flex items-center justify-between pt-4 border-t border-neutral-200 dark:border-neutral-700">
          <div>
            <div className="h-4 w-20 bg-neutral-200 dark:bg-neutral-700 rounded animate-pulse mb-2"></div>
            <div className="h-8 w-16 bg-neutral-200 dark:bg-neutral-700 rounded animate-pulse"></div>
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-20 bg-neutral-200 dark:bg-neutral-700 rounded animate-pulse"></div>
            <ChevronRight size={16} className="text-neutral-300 dark:text-neutral-600" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;